import { Box, Button, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface ManagingExportOptionsProps {
  successExport: boolean;
  closeModal: () => void;
}

export const BodySuccessExporting: FC = () => (
  <div className="loader-style-data-export-body-done">
    <div id="success_tic-data" className="success-modal-data-export">
      <div className="modal-content-success">
        <div className="page-body-data">
          <h1 className="h1-export-data-modal" style={{ textAlign: "center" }}>
            <div className="checkmark-circle-data">
              <div className="background-data" />
              <div className="checkmark-data draw-data" />
            </div>
          </h1>
        </div>
      </div>
    </div>
  </div>
);

export const ManagingExportOptions: FC<ManagingExportOptionsProps> = ({
  successExport,
  closeModal,
}) => {
  const [t] = useTranslation("global");

  if (successExport) {
    return (
      <div className="step-2-container">
        <div className="export-loader-container">
          <BodySuccessExporting />
          <div className="modal-export-email-text">{t("Data.Sent_file")}</div>
        </div>
        <div className="button-ok-done-export">
          <Button
            variant="outlined"
            sx={{ width: "95%", textTransform: "none" }}
            onClick={closeModal}
          >
            {t("Fleet_overview.search_sidebar.close")}
          </Button>
        </div>
      </div>
    );
  }
};

export function CustomTabPanel(props: Readonly<TabPanelProps>) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
